module.exports = __webpack_public_path__ + "static/UD-5fd61b0c6b765a1b24d007bd9a248cba.png";